import { Config } from '@/config/index';

export const overrideConfig: Partial<Config> = {
  firebase: {
    apiKey: 'AIzaSyAh2Au-mk5ci-hN83RUBqj1fsAmCMdvJx4',
    authDomain: 'mindx-edu-prod.firebaseapp.com',
    databaseURL: 'https://mindx-edu-prod.firebaseio.com',
    projectId: 'mindx-edu-prod',
    storageBucket: 'mindx-edu-prod.appspot.com',
    messagingSenderId: '469103925618',
    appId: '1:469103925618:web:06ab79fed8c9edcad2a5eb',
    measurementId: 'G-1GRNYT1ZCN',
  },
  base: {
    webUrl: 'https://base.mindx.edu.vn',
    apiUrl: 'https://gate-way.mindx.edu.vn/base-api/graphql',
    baseUrl: 'https://base-api.mindx.edu.vn',
    rootEndpoint: 'https://resources.mindx.edu.vn',
    uploadEndpoint: 'https://resources.mindx.edu.vn/api/v1/resources',
    imageEndpoint: 'https://resources.mindx.edu.vn/uploads/images',
    templateSource: '/uploads/documents/File update TMS -1723549263903-3516.xlsx',
  },
  identity: {
    url: 'https://id.mindx.edu.vn',
  },
  socketService: {
    main: 'ws://localhost:30916',
    url: 'wss://noti.mindx.edu.vn',
  },
  powerbiUrl: {
    link: 'app.powerbi.com',
    group: 'groups',
    report: 'report',
  },
  regex: {
    username: /^[a-zA-Z0-9\-.]{5,50}$/,
    email: /^[a-z0-9][a-z0-9_.]{0,40}@[a-z0-9]{2,}(.[a-z0-9]{2,4}){1,2}$/,
    phone: /^(\+84)([0-9]){9}$/,
    password: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,20}$/,
    url: new RegExp(
      [
        'https?://',
        '([a-zA-Z0-9-]+.)?',
        '(mindx.edu.vn|mindx.vn|mindx.com.vn|mindxspace.com)',
        '(/[-a-zA-Z0-9()@:%_+.~#?&//=]*)?',
      ].join(''),
    ),
  },
  i18n: {
    VI: 'vi',
    EN: 'en',
    defaultLang: 'vi',
  },
};